import { serverUrl, arrayLength } from "../config";
const autoApi = async (amount, mines, clientId, cellsToOpen) => {
  try {
    if (cellsToOpen.length < 1) {
      return null;
    }
    let req = {
      data: {
        numberOfCells: arrayLength,
        bombCounter: mines,
        clientBet: amount,
        clientId: clientId,
        cellsToOpen: cellsToOpen,
      },
    };

    const res = await fetch(`${serverUrl}/auto`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    });

    if (res.ok) {
      const jsonData = await res.json();
      return {
        clientId: jsonData["clientId"],
        currentBalance: jsonData["data"]["currentBalance"],
        currentMultiplier: jsonData["data"]["currentMultiplier"],
        minesIndexes: jsonData["data"]["minesIndexes"],
        result: jsonData["data"]["result"],
        winningAmount: jsonData["data"]["winningAmount"],
      };
    }
  } catch (e) {
    console.error(e);
  }
};
export default autoApi;
